<!-- v1 - in use -->

<template>
	<section id="options" class="del-dia-choice-options coto_container">
		<loadingAnimation v-if="loading"></loadingAnimation>

		<axiosError v-else-if="error"></axiosError>

		<div v-else class="slider">
			<nav v-if="products.choiceItems.length > 11" class="slider-nav coto_choice-slider-nav">
				<button v-on:click="slider" type="button" class="selected">I'll choose</button>
				<button v-on:click="slider" type="button" id="surpriseMeButton">Surprise Me</button>
			</nav>
			<div class="slider-items clearfix">
				<div v-if="products.choiceItems.length > 11" class="item active">
					<div v-if="refreshing" class="coto_grid-loader-container">
							<loadingAnimation></loadingAnimation>
						</div>
					<div class="coto_center">
						<div class="coto_choice-refresh-container"> 
							<button v-on:click="refreshGrid" class="coto_shuffle-color-button" type="button" id="choiceRefreshButton">{{shuffleButtonText}}</button>
						</div>
						<div class="coto_grid">
							<div v-for="product in products.choiceItems" class="coto_column coto_col-6 coto_col-lg-3">
								<figure v-on:click="openChoice(product)" :class="[{'soldout' : (product.inventoryCount == 0)},'choice-image']">
									<i class="icon-expand"></i>
									<div class="image-card">
										<img :src="product.images[0].src" :alt="product.images[0].alt">
									</div>
									<div v-if="!mobile" class="back image-card">
										<img :src="product.images[1].src" :alt="product.images[1].alt">
									</div>
									<strong v-if="product.inventoryCount == 0">Sold</strong>
								</figure>
							</div>
						</div>
					</div>
				</div>

				<div :class="[{'active' : (products.choiceItems.length < 12)}, 'item coto_choice-slider-body']">
					<div class="coto_center">
						<div class="coto_row">
							<div class="coto_column coto_col-md-6">
								<div class="coto_slideshow coto_fade-slide coto_slide-controls no-timer">
									<div class="coto_slide-items clearfix">
										<div v-for="image in products.images" class="coto_slide">
											<img :src="image.src" :alt="image.alt">
										</div>
									</div>
								</div>
							</div>
							<div class="coto_column coto_col-md-5">
								<div class="choice-detail sezzle-choice-input">
									<h2>{{ products.title }}</h2>
									<span v-if="productPronounce"><em>(Pronounced: {{productPronounce}})</em></span>
									<h3>Surprise Pack</h3>
									<strong v-if="parseInt(products.price) * 100 < comparePrice">${{ priceFilter(products.price) }} &nbsp;<span style="display:inline-block;"><s>${{ compareFilter(comparePrice) }}</s></span></strong>
									<strong v-else>${{ priceFilter(products.price) }}</strong>

									<div class="yotpo-rating">
										<a class="clearfix" href="#reviews_container"><div class="yotpo bottomLine" :data-product-id="products.id" :data-url="products.url"></div></a>
										<a class="clearfix"><div class='yotpo QABottomLine' data-appkey='oqN68L8QxaUkj7tQc6k1ODezyaTOoCrSCWFcfCqQ' :data-product-id='products.id'></div></a>
									</div>

									<p>Each pack in this collection is one-of-a-kind. We’ll choose a pack for you at random. Be prepared for a total surprise!</p>

									<div class="button-container">
										<button v-if="backorder" class="backorder coto_button" v-on:click="addToCart" :data-id="products.supriseMeVariantId">Back-Order</button>
										<small v-if="backorder" class="backorder-message">
											{{ products.backorderMessage }}
										</small>

										<button v-else-if="soldout" class="coto_button soldout">Sold out</button>

										<button v-else class="coto_button" v-on:click="addToCart" :data-id="products.supriseMeVariantId">Add to Cart</button>

										<!-- <div v-if="parseInt(products.price) * 100 > 4900" class="product-affirm">
											<p class="affirm-as-low-as" data-page-type="product" :data-amount="parseInt(products.price) * 100"></p>
										</div> -->

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-if="products.choiceItems.length > 11 && choiceID != null" class="item coto_choice-slider-body">
					<div class="coto_center">
						<button class="close" v-on:click="closeChoice" type="button"><i></i></button>
						<div class="coto_row">
							<div class="coto_column coto_col-md-6">
								<div class="coto_slideshow coto_fade-slide coto_slide-controls no-timer">
									<div class="coto_slide-items clearfix">
										<div v-for="image in choiceImages" :key="image.src" class="coto_slide">
											<img :src="image.src" :alt="image.alt">
										</div>
									</div>
								</div>
							</div>
							<div class="coto_column coto_col-md-5 coto_flex">
								<div class="choice-detail sezzle-choice-input">
									<h2>{{ products.title }}</h2>
									<span v-if="productPronounce"><em>(Pronounced: {{productPronounce}})</em></span>
									<h3>Choose Your Pack</h3>
									<strong  v-if="parseInt(choicePrice) * 100 < comparePrice">${{ priceFilter(choicePrice) }} &nbsp;<span style="display:inline-block;"><s>${{ compareFilter(comparePrice) }}</s></span></strong>
									<strong v-else>${{ priceFilter(choicePrice) }}</strong>
									<div class="yotpo-rating">
										<a class="clearfix" href="#reviews_container"><div class="yotpo bottomLine" :data-product-id="products.id" :data-url="products.url"></div></a>
										<a class="clearfix"><div class='yotpo QABottomLine' data-appkey='oqN68L8QxaUkj7tQc6k1ODezyaTOoCrSCWFcfCqQ' :data-product-id='products.id'></div></a>
									</div>

									<p>Act fast—we can’t hold this one-of-a-kind pack in your cart for very long. When it’s gone, it’s gone.</p>

									<div class="button-container add-to-cart">
										<button class="coto_button" v-on:click="addToCart" :data-id="choiceID">Add to Cart</button>
									</div>

									<!-- <div v-if="parseInt(products.price) * 100 > 4900" class="product-affirm">
										<p class="affirm-as-low-as" data-page-type="product" :data-amount="parseInt(products.price) * 100"></p>
									</div> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script src="./ctrl-del-dia-choice.js"></script>